import { Grid, Typography } from "@mui/material";

export default function Fillfirst() {
    return(
        <Grid xs={12} lg={12} margin='6%'>
        <Typography fontSize={'20px'} fontWeight='bold'>Fill all the required infromation first.....</Typography>
        </Grid>
    )
}